<template>
  <bottom-bar-layout v-if="!loading"
                     class="page-pay-center"
                     show-bar
                     :bar-height="barHeight"
                     :is-show-guide-popup="false"
                     v-ym-report:PAY_FORM_EXPOSURE=""
  >
    <ym-address v-if="address.show"
                :address="address"
                :redirect-to="redirectTo"
    />

    <product class="page-pay-center-product"
             :id="productRoute.id"
             :type="productRoute.type"
             :cover="product.cover"
             :title="product.title"
             :desc="product.desc"
             :price="product.price"
             :combo-list="render.comboProductList"
             :coin-exchange="render.coinExchange"
    />

    <require-field :field="requiredFields"
                   :redirect-to="redirectTo"
    />

    <div v-if="!appHideBenefit"
         class="page-pay-center-content"
    >
      <ym-count v-if="count && count.show"
                v-model="targetCount"
                :target-id="product.id"
                :target-type="product.productType"
                :coupon-ids="couponIds"
                :discount-ids="discountIds"
                :amount.sync="shouldPay"
                :balance-pay.sync="balancePay"
                :delivery.sync="delivery.price"
                :unit="count.unit"
                :hide-quota-text="count.hideQuotaText"
                :min="count.startSaleNum"
                :max="countMax"
                :stock="count.stock"
                :disabled-input="count.disabledInput"
                :address-id="addressId"
                @calculated="handleCountCalculated"
      />

      <ym-benefit v-if="render.benefit"
                  :target-id="product.id"
                  :target-type="product.productType"
                  :target-count="targetCount"
                  :price="render.orderAmount"
                  :amount.sync="shouldPay"
                  :balance-pay.sync="balancePay"
                  :delivery.sync="delivery.price"
                  :discounts="render.benefit.discounts"
                  :address-id="addressId"
                  :discount-save="discountSave"
                  :coupon-save="couponSave"
                  :subsidy-info.sync="render.subsidyInfo"
                  @chosen="handleChoseBenefit"
      />

      <ym-delivery v-if="render.delivery && render.delivery.show"
                   :type="render.delivery.type"
                   :price="render.delivery.price"
      />
    </div>

    <ym-cell v-if="render.message && render.message.show"
             class="page-pay-center-item page-pay-center-item--small"
             title="留言"
             size="small"
             :border="false"
    >
      <ym-field v-model="message"
                model="cell-item"
                :placeholder="render.message.hint"
                clearable
      />
    </ym-cell>

    <ym-payment :payment="payment"
                :balance-pay="balancePay"
    />

    <reminder v-if="render.reminder.show"
              :content="render.reminder.content"
    />

    <template #tabbar>
      <div class="page-pay-center-bottom-bar">
        <div v-if="notification && notification.show"
             class="page-pay-center-bottom-bar-notification ym-ellipsis"
        >
          {{ notification.text }}
        </div>
        <div class="page-pay-center-agreement">
          <template v-if="targetType === 'coinProduct'">
            点击兑换即表示您已同意
          </template>
          <template v-else>
            点击提交即表示您已同意
          </template>
          <router-link class="page-pay-center-agreement-link"
                       :to="{ name: 'PaymentAgreement' }"
          >《支付协议》
          </router-link>
        </div>
        <div class="page-pay-center-bottom-bar-content">
          <row-item class="page-pay-center-bottom-bar-should-pay">
            应付{{ payment.icon === 'balance-pay' ? '' : '金额' }}
            <div v-if="payment.icon === 'balance-pay'"
                 class="page-pay-center-bottom-bar-should-pay-balance"
            >
              {{ shouldPay }}<span class="name">少商币</span>
            </div>
            <ym-price v-else
                      class="page-pay-center-bottom-bar-should-pay-price"
                      :price="shouldPay"
                      :format-free="false"
                      size="large"
            />
          </row-item>
          <row-item class="page-pay-center-bottom-bar-create"
                    type="primary"
                    :disabled="disabledJoin"
                    @click="handleCreateOrder"
          >
            <template v-if="targetType === 'coinProduct'">
              确认兑换
            </template>
            <template v-else>
              确认支付
            </template>
          </row-item>
        </div>
      </div>
    </template>

  </bottom-bar-layout>
</template>

<script>
  import { Cell, Field } from '@ymba/ym-ui';
  import { decorator, after } from 'ym-reporter-vue';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import Address from '@/pages/Pay/components/PayCenterAddress';
  import Product from '@/pages/Pay/components/PayCenterProduct';
  import RequireField from '@/pages/Pay/components/PayCenterRequireField';
  import Count from '@/pages/Pay/components/PayCenterCount';
  import Benefit from '@/pages/Pay/components/PayCenterBenefit';
  import Delivery from '@/pages/Pay/components/PayCenterDelivery';
  import Reminder from '@/pages/Pay/components/PayCenterReminder';
  import RowItem from '@/components/YmTabbarItem/Row';
  import Price from '@/components/Price';
  import Payment from '@/pages/Pay/components/PayCenterPayment';
  import { showPayCenter } from '@/services/order';
  import createOrderMixin from '@/mixins/order/createOrder';
  import promptMessageMixin from '@/mixins/message/prompt';
  import {
    getProductPath, isMobileWeb, projectJump, getFromLocalStorage, removeFormStorage,
  } from '@/utils';
  import event from '@/utils/bus';

  export default {
    name: 'PayCenter',
    metaInfo: {
      title: '收银台',
    },
    mixins: [createOrderMixin, promptMessageMixin],
    components: {
      BottomBarLayout,
      'ym-address': Address,
      Product,
      RequireField,
      'ym-count': Count,
      'ym-cell': Cell,
      'ym-benefit': Benefit,
      'ym-delivery': Delivery,
      'ym-field': Field,
      Reminder,
      RowItem,
      'ym-price': Price,
      'ym-payment': Payment,
    },
    data() {
      return {
        isMobileWeb: isMobileWeb(),
        loading: true,
        couponIds: '',
        discountIds: '',
        targetCount: 1,
        message: '',

        product: {
          id: 0,
          productType: '',
          cover: '',
          title: '',
          desc: '',
          price: '',
          target: {
            id: 0,
            type: '',
          },
        },

        render: {
          orderAmount: 0,
          mobile: {
            show: false,
            value: '',
            hint: '',
          },
          trueName: {
            show: false,
            value: '',
            hint: '',
          },
          address: {
            show: false,
            value: null,
            hint: '',
          },
          email: {
            show: false,
            value: '',
            hint: '',
          },
          count: {
            show: false,
            startSaleNum: 1,
            quota: 0,
            disabledInput: false,
            hideQuotaText: false,
            unit: '',
            stock: 0,
          },
          benefit: null,
          delivery: {
            show: false,
            type: '',
            price: -1,
          },
          message: {
            show: false,
            placeholder: '特殊要求可留言，请先与客服协商一致',
          },
          pay: {
            payment: 'wxpay',
            agreement: {
              show: false,
              check: false,
            },
          },
          reminder: {
            show: false,
            content: '',
          },
          notification: {
            show: false,
            text: '',
          },
          subsidyInfo: {
            hint: '',
            value: '',
            show: false,
          },
          comboProductList: [],
        },

        shouldPay: 0,
        disabledJoin: false,
        balancePay: {
          showRechargeBtn: false,
          balance: '',
          rechargePath: '',
        },

        discountSave: 0,
        couponSave: 0,

        productRoute: null,
      };
    },
    computed: {
      payment() {
        const { payment } = this.render.pay;
        if (payment === 'alipay') {
          return { icon: 'alipay', text: '支付宝' };
        }
        if (payment === 'balancePay') {
          return { icon: 'balance-pay', text: '余额' };
        }
        return { icon: 'wxpay', text: '微信支付' };
      },
      redirectTo() {
        return this.$route.fullPath;
      },
      address() {
        const { render: { address = {} } = {} } = this;
        address.emptyMessage = '请选择收件地址';
        return address;
      },
      requiredFields() {
        const {
          mobile, trueName, email,
        } = this.render;

        mobile.title = '手机号码';
        mobile.emptyMessage = '请绑定手机号码';
        mobile.link = true;

        trueName.title = '孩子姓名';
        trueName.emptyMessage = '请填写孩子姓名';

        email.title = '电子邮箱';
        email.emptyMessage = '请填写电子邮箱';

        return {
          mobile,
          trueName,
          email,
        };
      },
      addressId() {
        const { render } = this;
        if (render == null) return 0;
        const { address } = render;
        if (address == null) return 0;
        const { value } = address;
        if (value == null) return 0;
        return value.id;
      },
      count() {
        return this.render.count;
      },
      countMax() {
        const { count } = this;
        if (!count || !count.show) return undefined;
        const { quota, stock } = count;
        if (quota > 0) return quota;
        if (stock > 0) return stock;
        return undefined;
      },
      notification() {
        return this.render.notification;
      },
      delivery() {
        const { delivery } = this.render;
        if (!delivery) {
          return {
            show: false,
            type: '',
            price: -1,
          };
        }
        return delivery;
      },
      barHeight() {
        const { notification = {}, render: { pay: { agreement = {} } } } = this;
        let res = 120;
        if (agreement && agreement.show) {
          res = 168;
        }
        if (notification && notification.show) {
          res = 208;
        }
        return res;
      },
      targetType() {
        return this.$route.query.targetType;
      },
      appHideBenefit() {
        return sessionStorage.getItem('appHideBenefit') || '';
      },
    },
    watch: {
      $route(val) {
        const { query: { targetCount } } = val;
        this.targetCount = targetCount;
      },
      balancePay: {
        deep: true,
        handler(val) {
          this.disabledJoin = val.showRechargeBtn;
        },
      },
    },
    methods: {
      getProductRoute(product) {
        if (product == null) {
          return { id: 0, type: '' };
        }
        const { id, type, target } = product;
        let route = target;
        if (target == null) {
          route = { id, type };
        }
        return route;
      },
      async showPayCenter(targetId, targetType, targetCount, addressId) {
        try {
          const data = await showPayCenter(targetId, targetType, targetCount, addressId);
          const { promptMessage, unpaid } = data;

          // 处理未支付订单
          if (unpaid != null) {
            // 调用mixin处理未支付订单
            this.mixinUnpaidOrderList = unpaid;
            this.mixinHandleUnpaidOrder();
            return;
          }

          // 处理下单冲突
          if (promptMessage != null) {
            // 调用mixin处理下单冲突信息
            this.mixinShowMessage(promptMessage, 'replace');
            return;
          }

          if (data.render.delivery) {
            const { show, price } = data.render.delivery;
            this.disabledJoin = show && price === -1;
          }
          if (data.render.balancePay && data.render.balancePay.showRechargeBtn) {
            this.disabledJoin = data.render.balancePay.showRechargeBtn;
          }

          this.product = data.product;
          this.render = data.render;
          this.shouldPay = data.render.orderAmount;
          this.balancePay = data.render.balancePay;

          this.productRoute = this.getProductRoute(data.product);

          this.loading = false;
        } catch (res) {
          const { msg: message, data } = res;
          const productRoute = this.getProductRoute(data.product);
          await this.$dialog.alert({ message });
          const route = getProductPath(productRoute.type, productRoute.id);
          projectJump(route, 1);
        }
      },

      initPageData() {
        const {
          targetId, targetType, targetCount, addressId,
        } = this.$route.query;
        this.showPayCenter(targetId, targetType, targetCount, addressId);
        this.targetCount = targetCount;
      },

      handleChoseBenefit(payload) {
        const { couponIds, discountIds } = payload;
        this.couponIds = couponIds;
        this.discountIds = discountIds;
      },

      handleCountCalculated(save) {
        this.discountSave = save.discount;
        this.couponSave = save.coupon;
      },

      validatorItem(object) {
        const result = !object || !object.show || (object.value != null && object.value !== '');
        if (!result) {
          this.$toast(object.emptyMessage);
        }
        return result;
      },

      validatorOrderForm() {
        const { requiredFields: fields, address, render: { delivery = {} } } = this;
        const { show: addressShow, value } = address || {};
        const { show: deliveryShow, price } = delivery || {};
        // 地址为空
        const emptyAddress = value == null;
        // 配送方式不正确
        const deliveryError = deliveryShow && price < 0;
        // 展示地址，同时地址为空 或 配送方式不正确
        if (addressShow && (emptyAddress || deliveryError)) {
          this.$toast(address.emptyMessage);
          return false;
        }

        // 必填信息
        const errorField = Object.keys(fields).find(key => !this.validatorItem(fields[key]));

        return errorField == null;
      },

      async handleCreateOrder() {
        this.disabledJoin = true;
        if (!this.validatorOrderForm()) {
          this.disabledJoin = false;
          return;
        }
        // 记录并创单
        this.recordCreateOrder();
      },

      @decorator(after(function () {
        const payOriginInfo = window.sessionStorage.getItem('pay-origin-info');
        if (payOriginInfo) {
          this.$reporter.report('PAY_FORM_PAY_BUTTON_CLICK', JSON.parse(payOriginInfo));
          window.sessionStorage.removeItem('pay-origin-info');
          return;
        }
        this.$reporter.report('PAY_FORM_PAY_BUTTON_CLICK');
      }))
      async recordCreateOrder() {
        this.disabledJoin = true;
        const { targetId, targetType } = this.$route.query;
        const {
          couponIds,
          discountIds,
          shouldPay,
          addressId,
          targetCount,
          message,
        } = this;
        const params = {
          targetId,
          targetType,
          targetCount,
          couponIds,
          discountIds,
          shouldPay,
          message,
          payActionSource: 'payCenter',
        };
        if (addressId > 0) {
          params.addressId = addressId;
        }
        try {
          // 调用 mixin 创建订单
          await this.mixinCreateOrder(params);
          this.disabledJoin = false;
        } catch (e) {
          this.disabledJoin = false;
          const { msg } = e || {};
          if (msg && msg !== '') {
            this.$dialog.alert({ message: msg });
          }
        }
      },
    },
    created() {
      this.initPageData();
      event.$on('reloadWebviewData', () => {
        this.initPageData();
      });
      if (getFromLocalStorage('pay-center-back')) {
        removeFormStorage('pay-center-back');
        this.$router.back();
      }
    },
    beforeRouteUpdate(to, from, next) {
      const {
        targetId, targetType, targetCount, addressId,
      } = to.query;
      this.showPayCenter(targetId, targetType, targetCount, addressId);
      next();
    },
    destroyed() {
      this.$reporter.report('PAY_FORM_CLOSE');
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-center {
    min-height: 100%;
    &-header {
      width: 100%;
      height: 88px;
      box-sizing: border-box;
      padding: 0 @size-base;
      font-size: @font-size-large;
      font-weight: @font-weight-primary;
      color: @color-text-base;
      background: @color-white;
      text-align: center;
      display: flex;
      align-items: center;
      border-bottom: @border-base;

      &-icon {
        font-size: @font-size-medium;
      }

      &-text {
        padding-right: @size-small;
        flex: 1;
      }
    }

    &-product {
      + .page-pay-center-parameter {
        margin-top: -@size-extra-small;
      }
    }

    &-content {
      padding: 0 @size-base @size-base;
      background: @color-white;
      margin-bottom: @size-small;

      &-price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: @size-base;
        padding-top: @size-medium;

        &-name {
          font-weight: @font-weight-bold;
        }
      }
    }

    &-item {
      margin: @size-small 0;

      &--small {
        min-height: 88px;
      }

      /deep/ .ym-cell-text {
        color: @color-text-base;
      }
    }

    &-payment {
      &-icon {
        margin-right: @size-extra-small;
        font-size: 34px;

        &.is-wxpay {
          color: @color-wechat;
        }

        &.is-alipay {
          color: @color-alipay;
        }
      }

      &-text {
        color: @color-text-light;
      }
    }

    &-bottom-bar {
      overflow: hidden;
      flex: 1;
      display: flex;
      flex-direction: column;

      @notification-bar-height: 40px;

      &-notification {
        height: @notification-bar-height;
        padding: 0 @size-small;
        line-height: @notification-bar-height;
        font-size: @font-size-small;
        color: @color-highlight;
        background: @color-highlight-light;
      }

      &-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        padding: 0 @size-base;
      }

      &-should-pay {
        justify-content: flex-start;
        flex: 1;

        &-balance {
          margin-left: @size-small;
          color: #fa405e;
          font-size: @font-size-medium;
          font-weight: @font-weight-strong;
          .name {
            font-size: @font-size-base;
          }
        }

        &-price {
          margin-left: @size-small;

          /deep/ .price-unit {
            padding-bottom: 2px;
          }
        }
      }

      &-create {
        flex-shrink: 0;
        flex-grow: 0;
        flex-basis: auto;
        white-space: nowrap;
        height: 80px;
        width: 220px;
        border-radius: 50px;
      }
    }

    &-agreement {
      padding: @size-small @size-base;
      display: flex;
      align-items: center;
      line-height: 1;
      font-size: @font-size-base;
      color: @color-text-lighter;

      &-link {
        color: @color-text-primary;
      }
    }
  }
</style>
